import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export function Profile() {
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
        Profile
      </Typography>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          Profile Component
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This will contain user profile information, password change, and personal settings.
        </Typography>
      </Paper>
    </Box>
  );
} 